export const getAccountType = user => {
  switch (user.accountType) {
    case 'free':
      return 'Free Account';
    case 'premium':
      return 'Premium Account';
    default:
      return '';
  }
};

export const formatCurrency = (value) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(value);

